import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { ApiPartnerService } from '@app/api/api-partner.service';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-manage-prov-form',
  templateUrl: './manage-prov-form.component.html',
  styleUrls: ['./manage.component.css']
})
export class ManageProvFormComponent implements OnInit {
  
  formProv = this.fb.group({
    servicename: [''],
    provisioningcode: [''],
    productsource: [''],
    statusid: ['']
  });

  loadingForm = false;
  showChannel = false;
  optionProductsource : any = [];
  
  //ALERT
  alert_failed = false;
  alert_success = false;
  successreg : string;
  errorreg : string;

  id : string = '';
  item = {};
  constructor(
    public partnerService: ApiPartnerService,
    private route:ActivatedRoute,
    private fb:FormBuilder,
    private router:Router
  ) { }

  ngOnInit() {
    this.loadStart();
  }

  loadStart(){
    let id = this.route.snapshot.paramMap.get('id');
    if(id != null){
      this.id = id;
      this.showChannel = true;
      this.detailProvisioning(this.id);
      console.log(this.item);      
    }

    this.loadForm();
  }

  loadForm() {
    this.listProductsource();
  }

  listProductsource(){
    return this.partnerService.GetProductsource().subscribe((output: any) => { this.optionProductsource = output.data; });
  }
  detailProvisioning(id:any){
    return this.partnerService.GetDetailprovisioning(id).subscribe((output: any) => { 
      this.item = output.data.data; 
    });
  }

  saveProvisioning() {
    console.log(this.formProv.value);

    this.partnerService.PostCreateProvisioning(this.formProv.value)
      .subscribe((response: any) => {        
        if (response.status == true) {
          //this.alert_success  = true;
          //this.loadingForm    = true;

          //this.successreg = response.message;
          this.alertsukses("Prosioning Diperbarui.");
          //setTimeout(()=>{
            //this.alert_success = false;
            //this.loadingForm   = false;
            //this.formProv.reset();
            this.router.navigate(['/manage/provisioning-form/'+response.data.id]);
          //}, 1000);          
        } 
        else {
          this.alert_failed = true;
          this.loadingForm    = true;
          
          this.errorreg = response.data.message;
          setTimeout(()=>{
            this.alert_failed = false;
            this.loadingForm   = false;
          }, 6000);

        }        
      }      
    );
  }

  editProvisioning(item:any) {
    //console.log(item,this.formProv.value);    
    
    this.partnerService.PostEditProvisioning(item.id,this.formProv.value)
    .subscribe((response: any) => {        
        if (response.status == true) {
          console.log(response)

          this.loadStart();
          //this.loadingForm   = true;
          //this.alert_success = true

          //this.successreg = response.message;
          //setTimeout(()=>{ this.loadingForm   = false;}, 500);
          this.alertsukses("Prosioning Diperbarui.");
          //setTimeout(()=>{ this.alert_success = false;}, 6000);          
        } 
        else {
          //this.alert_failed = true;
          //this.loadingForm   = true;
          
          this.errorreg = response.message;
         // setTimeout(()=>{ this.loadingForm   = false;}, 1000);
          //setTimeout(()=>{ this.alert_failed = false;}, 6000);   
        }        
      }      
    );
  }  

  alertsukses(item:any){
    swal({
      title: "Sukses!",
      text: item,
      icon: "success",
      button: "OK",
      timer: 1500
    });
  }
  alertgagal(item:any){

    swal({
      title: "Gagal!",
      text: item,
      icon: "error",
      button: "OK",
    });
  }
}
